export class Eventos {
  eventId: number;
  contentId: number;
  id: number;
  title: string;
  allDay: boolean;
  start: Date;
  end: Date;
  url: string;
  createdOn: Date;
  modifiedOn: Date;
  createdBy: string;
  modifiedBy: string;
  desc: string;
  shortDesc: string;
}



// WEBPACK FOOTER //
// ./src/app/events/shared/event.model.ts